import { Section } from '~/components/common/section';
import { SubMenu } from './submenu';

interface SubMenuLayoutProps {
   children: React.ReactNode;
   menuItems: {
      href: string;
      text: React.ReactNode;
      description?: React.ReactNode;
      isComplete?: boolean;
   }[];
   title?: React.ReactNode;
   description?: React.ReactNode;
   isSteps?: boolean;
}

export const SubMenuLayout = ({
   children,
   menuItems,
   title,
   description,
   isSteps,
}: SubMenuLayoutProps) => {
   return (
      <div className="relative flex h-full">
         <div className="inset-x-0 lg:block hidden flex-shrink-0 lg:w-[260px] ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 border-r">
            <Section className="h-full py-5 mt-3 bg-transparent shadow-none">
               <div className="fixed px-2 lg:w-[245px]">
                  <div className="relative block mb-2 text-lg font-bold text-primary">
                     {title}
                     <div className="h-1 w-[40px] absolute border-b-2 border-primary ltr:left-0 rtl:right-0 mt-1.5"></div>
                  </div>
                  <p className="my-5 text-sm font-light text-grey-100">{description}</p>
                  <div>
                     <SubMenu links={menuItems} isSteps={isSteps} />
                  </div>
               </div>
            </Section>
         </div>
         <div className="flex-grow py-5 mx-0 md:mx-2">{children}</div>
      </div>
   );
};
